import React from "react";
import styled from "styled-components";
import { ButtonIcon } from "@loanbossinc/component-library";

const GridHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: start;
    align-items: center;
`;
const HeaderCell = styled.div`
    display: flex;
    width: 575px;
    height: 74px;

    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    align-items: center;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    padding-left: 11px;

    color: #000000;
    text-align:center;
`;
const HeaderCellSm = styled(HeaderCell)`
    width: 150px;
    padding: 11px;
`;
const HeaderCellMd = styled(HeaderCell)`
    width: 250px;
    padding: 11px;
`;
const GridDataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`;
const DataWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
`;
const CompanyCell = styled.div`
    display: flex;
    align-items: center;
    width: 497px;
    height: 54px;

    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
`;
const CompanyItem = styled.div`
    display: flex;
    align-items: center;
    width: 575px;
    height: 54px;

    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    padding-left: 11px;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;

    color: #000000;
`;
const CompanyItemSm = styled(CompanyItem)`
    width: 150px;
    justify-content: center;
`;
const EditIcon = styled(CompanyCell)`
    width: 250px;
    justify-content: center;
`;

export default function CompaniesGrid({ companies, onClick }) {
  if (!companies || companies.length === 0) {
    return null;
  }

  return (
    <>
      <GridHeaderWrapper>
        <HeaderCell>Broker Company Name</HeaderCell>
        <HeaderCellSm>Number of Sponsors</HeaderCellSm>
        <HeaderCellMd>Authorized Sponsor Settings</HeaderCellMd>
      </GridHeaderWrapper>
      <GridDataWrapper>
        {companies.map(x => (
          <DataWrapper>
            <CompanyItem>{x.name}</CompanyItem>
            <CompanyItemSm>{x.sponsorCompanies ? x.sponsorCompanies.length : 0}</CompanyItemSm>
            <EditIcon>
              <div style={{ "marginRight": "11px" }}>
                <ButtonIcon
                  hasBorder={false}
                  iconName="edit"
                  onClick={() => onClick(x.id)}
                />
              </div>
            </EditIcon>

          </DataWrapper>
        ))}
      </GridDataWrapper>
    </>
  );
}
